<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ "SHARED_CART.TITLE" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/cart" class="text-primary" mode="md"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="flex h-full justify-center">
    <div class="flex w-full flex-col md:max-w-[650px]">
      @if (isLoading()) {
        <div class="flex h-full w-full items-center justify-center">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
        </div>
      } @else if (error()) {
        <div class="flex h-full w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_orders.svg"
            darkSrc="/assets/no_orders_dark.svg"
            class="size-[220px] opacity-80 dark:opacity-70"
          />
          <p class="text-medium/70 mt-2 text-center">{{ error() }}</p>
          <ion-button routerLink="/cart" class="mt-4" fill="outline">
            {{ "SHARED_CART.GO_TO_CART" | translate }}
          </ion-button>
        </div>
      } @else if (sharedCartItems().length) {
        <ion-card class="mt-5 overflow-y-auto border-none">
          <ion-list class="bg-transparent !m-0 !p-0">
            @for (item of sharedCartItems(); track $index) {
              <div class="flex items-center px-2 py-4 hover:bg-light">
                <img
                  [src]="item.product.images?.[0] || getItemVariation(item)?.image"
                  class="w-24 aspect-square rounded-xl p-[0.2px] border border-solid border-medium/30 me-2 object-cover"
                  alt="thumbnail"
                />
                <div class="ms-2 flex flex-1 flex-col">
                  <div class="flex flex-wrap justify-end gap-2 pe-2">
                    <ion-text class="me-auto ms-3 pe-4 font-bold">{{ item.product.name }}</ion-text>

                    @for (attr of getItemVariation(item)?.attributes; track $index) {
                      @if (attr.type !== "color") {
                        <div
                          class="border-primary text-primary bg-primary/10 min-w-6 rounded-full px-2 py-1 text-center"
                        >
                          <ion-label>
                            {{ "ATTRIBUTE." + attr.typeLabel.toUpperCase() | translate }} - {{ attr.label }}
                          </ion-label>
                        </div>
                      } @else {
                        <div
                          class="border-medium !m-0 flex size-6 items-center justify-center rounded-full border-2 border-solid !p-0 text-white"
                          [ngStyle]="{
                            'background-color': attr.key,
                          }"
                        ></div>
                      }
                    }
                  </div>
                  <ion-text class="ms-3 mt-1">
                    <span class="text-primary text-sm font-bold">
                      {{ getItemPrice(item) | vxCurrency }}
                    </span>
                    @if (item.product.discount || getItemVariation(item)?.discount) {
                      <span class="text-medium text-md ms-3 line-through">
                        {{ getItemVariation(item)?.price || item.product.price || 0 | vxCurrency }}
                      </span>
                    }
                  </ion-text>
                  <div class="flex flex-1 items-center mt-2">
                    <ion-text class="ms-3 text-medium">
                      {{ "COMMON.QUANTITY" | translate }}: {{ item.quantity }}
                    </ion-text>
                  </div>
                </div>
              </div>
              @if ($index !== sharedCartItems().length - 1) {
                <div class="bg-light ms-32 h-[1px] w-full"></div>
              }
            }
          </ion-list>
        </ion-card>

        <ion-button
          expand="block"
          color="primary"
          class="mx-4 mb-4 mt-6 h-10 capitalize"
          (click)="replaceCart()"
          [disabled]="isReplacing()"
        >
          @if (isReplacing()) {
            <ion-spinner name="crescent"></ion-spinner>
          } @else {
            {{ "SHARED_CART.REPLACE_WITH_CURRENT_CART" | translate }}
          }
        </ion-button>
      } @else {
        <div class="flex h-full w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_orders.svg"
            darkSrc="/assets/no_orders_dark.svg"
            class="size-[220px] opacity-80 dark:opacity-70"
          />
          <p class="text-medium/70 mt-2 text-center">{{ "SHARED_CART.EMPTY" | translate }}</p>
        </div>
      }
    </div>
  </div>
</ion-content>
